import _ from 'lodash'

import i18n from '@/i18n/i18n'
import WorkflowService from '@/services/admin/WorkflowService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  orderWorkflows: null,
  workflowJobs: null,
  workflowJob: {}
}

export const mutations = {
  SET_ORDER_WORKFLOWS(state, orderWorkflows) {
    state.orderWorkflows = orderWorkflows
  },
  SET_WORKFLOW_JOBS(state, workflowJobs) {
    state.workflowJobs = workflowJobs
  },
  SET_WORKFLOW_JOB(state, workflowJob) {
    state.workflowJob = workflowJob
  }
}
export const getters = {
  getOrderWorkflows: state => {
    return state.orderWorkflows
  }
}

export const actions = {
  getWorkflowJobs({ commit, dispatch }, query = {}) {
    return new Promise((resolve, reject) => {
      WorkflowService.getWorkflowJobs(query)
        .then(response => {
          commit('SET_WORKFLOW_JOBS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.workflow.order_workflows')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getWorkflowJob({ commit }, id) {
    return new Promise((resolve, reject) => {
      WorkflowService.getWorkflowJob(id)
        .then(response => {
          commit('SET_WORKFLOW_JOB', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createWorkflowJob({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      WorkflowService.createWorkflowJob(params)
        .then(response => {
          commit('SET_WORKFLOW_JOBS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.workflow.order_workflow')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateWorkflowJob({ state, commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      WorkflowService.updateWorkflowJob(state.workflowJob.id, params)
        .then(response => {
          commit('SET_WORKFLOW_JOB', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.workflow.order_workflow')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getWorkflowJobsCartesian({ dispatch }, query = {}) {
    return new Promise((resolve, reject) => {
      WorkflowService.getWorkflowJobs(query)
        .then(response => {
          let list = []
          let colorClass = 'mdi '
          _.each(response.data, workflowJobItem => {
            _.each([0, 1], status => {
              let itemClass = colorClass + (status === 1 ? 'mdi-check' : 'mdi-close')
              list.push({
                id: workflowJobItem.id + '_' + status,
                name: workflowJobItem.name,
                icon: itemClass
              })
            })
          })

          resolve(list)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.workflow.order_workflows')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getOrderWorkflows({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      WorkflowService.getOrderWorkflows(id)
        .then(response => {
          commit('SET_ORDER_WORKFLOWS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.workflow.order_workflow_job')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createOrderWorkflow({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      WorkflowService.createOrderWorkflow(params.orderId, params.workflowId)
        .then(response => {
          let notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.workflow.order_workflow')
            })
          }

          if (params.hasOwnProperty('message')) {
            notification.message = params.message
          }

          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
